module.exports = __webpack_public_path__ + "images/emoji/pineapple.794efd0f6952cf77f5c7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pineapple.png
// module id = o4i+
// module chunks = 1